import { Button } from '@mantine/core';
import PropTypes from 'prop-types';
import React from 'react';
import ImagePicker from '../../elements/ImagePicker/ImagePicker';
import styles from './styles.scoped.css';

export default function IdentityPhotoForm({
  handleSubmit,
  handleClose,
  // initialValues = {},
  // invalid = true
}) {

  const [files, setFiles] = React.useState([]);

  const onSubmit = async (e) => {
    e.preventDefault();
    handleSubmit(files);
  };
  return (
    <form onSubmit={onSubmit}>
      <ImagePicker
        info={'Gambar maksimal 2 MB dengan format PNG atau JPG.'}
        maxSize={2000000}
        onSelect={(e) => setFiles(e)}
        title={'Foto KTP'}
      />
      <div className={styles.containerButton}>
        <Button className={styles.buttonLeft} fullWidth={true} onClick={handleClose} variant="outline">Batal</Button>
        <Button
          disabled={!files.length}
          fullWidth={true} type="submit" >Unggah dan Ganti Foto KTP</Button>
      </div>
    </form>
  );
}

IdentityPhotoForm.propTypes = {
  handleClose: PropTypes.func,
  handleSubmit: PropTypes.func,
  initialValues: PropTypes.object,
  invalid: PropTypes.bool,
};
